import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const deleteCrmProject = async (id: Tables<"crm_project">["id"]) =>
  await supabase.from("crm_project").delete().eq("id", id).throwOnError();
